import axios from "axios";
import { API_BASE } from "../../config/env";
import { CHECKOUT_BASE } from "../../config/env";

export const FETCH_GETCITIESBYDISTRICTNAME_FULFILLED = "FETCH_GETCITIESBYDISTRICTNAME_FULFILLED";
export const FETCH_GETCITIESBYDISTRICTNAME_REJECTED = "FETCH_GETCITIESBYDISTRICTNAME_REJECTED";
export const FETCH_GETCITIESBYDISTRICTNAME_PENDING = "FETCH_GETCITIESBYDISTRICTNAME_PENDING";
export const RESET_GETCITIESBYDISTRICTNAME = "RESET_GETCITIESBYDISTRICTNAME";

export function getCitiesByDistrictName(cityName) {
  const token = localStorage.getItem("accessToken");
  return (dispatch) => {
    dispatch({
      type: "FETCH_GETCITIESBYDISTRICTNAME",
      payload: axios({
        method: "get",
        url: `${CHECKOUT_BASE}/gate/address/lookup/10/${cityName}`,
        headers: {
          Authorization: "Bearer " + token,
          "Accept-Language": "tr-tr",
          "Content-Type": "application/json",
          "Cart-Type": "fast-checkout"
        },
      }).then((result) => result.data),
    });
  };
}

export function resetGetCitiesByDistrictName() {
  return (dispatch) => {
    dispatch({
      type: "RESET_GETCITIESBYDISTRICTNAME",
    });
  };
}
